import React from 'react';
import { useHeaderLinksStyles } from './styles';
import {
  simple,
  ripleyBank,
  ripleyGoPoints,
  ripleyInsurance,
} from '../../../config/paths';

const HeaderLinks = () => {
  const classes = useHeaderLinksStyles();

  return (
    <React.Fragment>
      <div className={classes.root}>
        <nav>
          <ul>
            <li>
              <a href={simple} target="blank">
                Ripley.com
              </a>
            </li>
            <li>
              <a href={ripleyBank} target="blank">
                Banco Ripley
              </a>
            </li>
            <li>
              <a href={ripleyGoPoints} target="blank">
                Ripley Puntos Go
              </a>
            </li>
            <li>
              <a href={ripleyInsurance} target="blank">
                Seguros Ripley
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </React.Fragment>
  );
};

export default HeaderLinks;
